angular.module 'app'
.controller 'GraphicAnalysisLayoutCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->
  $scope.permission = Storage.get('user_permission')
